import { z } from 'zod';

import { chatUiBase } from '../../shared/schema/base.js';

/** Cap de candidatas no card — mantém o frame SSE limitado em desambiguações
 *  largas (o agents fatia antes de projetar). */
export const CHAT_UI_MAX_BUS_STOP_OPTIONS = 10;

/**
 * Uma candidata de rodoviária — SÓ o nome. Os códigos do provider ficam
 * server-side (`pendingStopCandidates` no agents); o toque resolve POR NOME
 * (quick-reply), então nenhum código viaja no wire.
 */
const ChatUiBusStopOptionSchema = z
  .object({
    name: z.string().min(1),
  })
  .strict();
export type ChatUiBusStopOption = z.infer<typeof ChatUiBusStopOptionSchema>;

/** Membro `bus_stops` do `ChatUiSchema` (discriminatedUnion) — desambiguação de
 *  rodoviária por toque. `which` localiza o título do card (origem/destino). */
export const BusStopsBlockSchema = z
  .object({
    ...chatUiBase,
    kind: z.literal('bus_stops'),
    which: z.enum(['origin', 'destination']),
    options: z.array(ChatUiBusStopOptionSchema).min(1).max(CHAT_UI_MAX_BUS_STOP_OPTIONS),
  })
  .strict();
export type BusStopsBlock = z.infer<typeof BusStopsBlockSchema>;
